import PurchaseOrderList from "../features/purchase/PurchaseOrderList";

const PurchaseOrderPage = () => {
  return <PurchaseOrderList />;
};

export default PurchaseOrderPage;
